<template>
  <div>
    <b-tabs justified active-nav-item-class="font-weight-bold text-uppercase text-dark" @activate-tab="refreshTab">
      <b-tab title="Resumen">
        <section class="metrics-dashboard">
          <header class="metrics-dashboard__header"><div><AppIcon name="insights" /><strong> Resumen operativo</strong><small>Vista consolidada para los filtros seleccionados.</small></div><b-button variant="link" class="list-view-icon-btn" v-b-tooltip.hover title="Actualizar resumen" @click="refreshSummary"><AppIcon name="refresh" /></b-button></header>
          <b-overlay :show="arrUnitMeasurement == 'S/D'" rounded="sm"><b-row class="metrics-dashboard__stats"><b-col md="6"><div class="metrics-stat"><small>Cantidad de ítems</small><strong v-for="(item,index) in arrUnitMeasurement" :key="'detail_unit_'+index">{{formatNumber(item.count)}} {{item.reference}}</strong></div></b-col><b-col md="6"><div class="metrics-stat"><small>Total de pedidos</small><strong>{{formatCurrency(total)}}</strong></div></b-col></b-row></b-overlay>
          <b-row><b-col md="6"><section class="metrics-panel"><header><div><AppIcon name="format_list_numbered" /><strong>Ítems más vendidos</strong></div><small>Por cantidad</small></header><b-overlay :show="arrItems == 'S/D'" rounded="sm"><div class="metrics-panel__rows"><div v-for="(item,index) in arrItems" :key="'detail_items_'+index" class="metrics-row"><span class="metrics-row__rank">{{index+1}}</span><div class="metrics-row__label"><strong><span v-if="item.code">{{item.code}} · </span>{{item.name}}</strong><span class="metrics-row__bar"><i :style="{width:percentage(item.count, arrItems)+'%'}"></i></span></div><strong>{{formatNumber(item.count)}}</strong></div><div v-if="arrItems !== 'S/D' && !arrItems.length" class="metrics-empty">No hay datos para mostrar.</div></div></b-overlay></section></b-col><b-col md="6"><section class="metrics-panel"><header><div><AppIcon name="flag" /><strong>Totales por estado</strong></div><small>Importe acumulado</small></header><b-overlay :show="arrStatus == 'S/D'" rounded="sm"><div class="metrics-panel__rows"><div v-for="(item,index) in arrStatus" :key="'detail_status_'+index" class="metrics-row"><span class="metrics-status" :style="{backgroundColor:item.color}"></span><div class="metrics-row__label"><strong>{{item.label}}</strong></div><strong>{{formatCurrency(item.total)}}</strong></div><div v-if="arrStatus !== 'S/D' && !arrStatus.length" class="metrics-empty">No hay datos para mostrar.</div></div></b-overlay></section></b-col></b-row>
        </section>
      </b-tab>
      <b-tab title="Datos">
        <DynamicSummary ref="dynamicSummary" storage-key="dynamic_summary_metrics_orders" export-filename="metricas-pedidos" :dimensions="report.dimensions" :default-groups="report.defaultGroups" :load-report="loadReport" :export-options="[{key:'detail-items',label:'CSV completo'}]" :exporting="exporting" quantity-label="Cantidad" @export="downloadSource" @error="showReportError" />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
  import serviceAPI from './../services'
  import Funciones from '@/handler/funciones'
  import Helper from '@/handler/helper'     
  import DynamicSummary from '@/components/inc/reporting/DynamicSummary'

  export default {
    props:{
      filters: {
        type: Object,
        default: null,
      },
    },    
    components: {
      DynamicSummary,
    },    
    data() {
      return {                
        total: 0,
        arrItems: 'S/D',
        arrStatus: 'S/D',
        arrUnitMeasurement: 'S/D',
        configurations: null, 
        arr: {
          status: [],
          status_alt: []
        },
        currency: 'ARS',
        itemsForceUpdate: 0,   
        exporting: false,
        report: {
          defaultGroups: ['year', 'month'],
          dimensions: [
            { key: 'year', label: 'Año' }, { key: 'month', label: 'Mes' },
            { key: 'seller', label: 'Vendedor' }, { key: 'customer', label: 'Cliente' },
            { key: 'item', label: 'Ítem' }, { key: 'currency', label: 'Moneda' },
          ],
        },
      }
    },
    mounted() {
      this.loadConfigurations()                  
    },    
    methods: {   
      // CONFIGURATIONS
      loadConfigurations() {
        var result = serviceAPI.obtenerConfiguracion('orders')

        result.then((response) => {
          var data = response.data                  
          this.configurations = data    
          
          this.setStatus()  
          this.getResumen()
        })      
      },        
      
      // STATUS ALTERNTIVOS    
      setStatus() {
        var arrStatus = this.configurations[9].value_string.split(',')
        var haveSystemManufacture = this.configurations[4].value_string
        var showStatusInProcess = this.configurations[13].value_boolean

        this.arr.status = []

        if(showStatusInProcess) {
          if(arrStatus[0])
            this.arr.status.push({code:'in_process', label: arrStatus[0], color:'#c1bb00', order:1})
        }
        
        if(arrStatus[1])
          this.arr.status.push({code:'closed', label: arrStatus[1], color:'#1a85e0', order:2})
        
        if(haveSystemManufacture) {        
          this.arr.status.push({code:'pending_manufacture', label: this.configurations[11].value_string, color:'#c72eda', order:3})  
          this.arr.status.push({code:'error_manufacture', label: this.configurations[12].value_string, color:'#ff1f1f', order:4})
        }

        if(arrStatus[2])
          this.arr.status.push({code:'in_preparation', label: arrStatus[2], color:'#582eda', order:5})
        
        if(arrStatus[3])
          this.arr.status.push({code:'pending_shipping', label: arrStatus[3], color:'#ce7910', order:6})
        
        if(arrStatus[4])
          this.arr.status.push({code:'in_transport', label: arrStatus[4], color:'#33bf8c', order:7})
        
        if(arrStatus[5])
          this.arr.status.push({code:'delivered', label: arrStatus[5], color:'#3e9619', order:8})

        if(arrStatus[6])
          this.arr.status.push({code:'cancel', label: arrStatus[6], color:'#d23829', order:9})
      }, 
      getNameStatus(value) {
        var itemSelected = null
        this.arr.status.forEach(element => {          
          if(element.code == value) {
            itemSelected = element
          }
        });
        
        if(itemSelected) {
          return '<span style="background-color:' + itemSelected.color + '; color: #fff; font-size:12px; font-weight:700; padding: 2px;">'+ itemSelected.label +"</span>"
        } else {
          return ""
        }
      }, 
      getElementByStatus(value)  {
        var itemSelected = null
        this.arr.status.forEach(element => {          
          if(element.code == value) {
            itemSelected = element
          }
        });
        return itemSelected
      },
 
      // RESUMEN
      getResumen() {                      
        var filters = this.getReportFilters()
        
        var result = serviceAPI.getResumen('orders', filters)        
        result.then((response) => {                   
          var data = response.data

          //currency
          this.currency = this.normalizeCurrency(data.currency)

          //total
          this.total = this.parseNumeric(data.total)

          //status
          this.arrStatus = []
          for(const prop in data.status) {
            var statusSelected = this.getElementByStatus(prop)
            if(statusSelected) {
              this.arrStatus.push({
                code: prop,
                label: statusSelected.label,
                tag: this.getNameStatus(prop),
                color: statusSelected.color,
                order: statusSelected.order,
                status: prop,
                total: this.parseNumeric(data.status[prop]),
              })
            }
          }
          Funciones.sortArrayInteger(this.arrStatus, 'order', 1)        

          //unit
          this.arrUnitMeasurement = []
          for(const prop in data.unit) {
            this.arrUnitMeasurement.push({
              reference: prop,
              count: this.parseNumeric(data.unit[prop]),
            })
          }

          //items
          this.arrItems = []
          for(const prop in data.items) {
            this.arrItems.push({
              code: data.items[prop].code,
              name: data.items[prop].name,
              count: this.parseNumeric(data.items[prop].count),
            })
          }
          Funciones.sortArrayInteger(this.arrItems, 'count', -1)        
          this.setItemForceUpdate()          
        })                          
      },   
      refreshSummary() {
        this.getResumen()
      },
      refreshTab(index) {
        if(index === 0) this.refreshSummary()
        else this.$nextTick(() => { if(this.$refs.dynamicSummary) this.$refs.dynamicSummary.reload() })
      },
      normalizeCurrency(value) {
        var currency = (value || '').toString().trim().toUpperCase()
        if(currency.length !== 3) {
          currency = 'ARS'
        }
        return currency
      },
      parseNumeric(value) {
        var number = parseFloat(value)
        if(Number.isNaN(number)) {
          return 0
        }
        return number
      },
      formatCurrency(value) {
        var amount = this.parseNumeric(value)
        var currency = this.normalizeCurrency(this.currency)
        try {
          return Intl.NumberFormat('es-AR',{style:'currency',currency:currency}).format(amount)
        } catch (e) {
          return Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format(amount)
        }
      },
      formatNumber(value) {
        return Intl.NumberFormat('es-AR',{ maximumFractionDigits: 0 }).format(this.parseNumeric(value))
      },
      percentage(value, values) {
        var maximum = Math.max.apply(null, (values || []).map(item => this.parseNumeric(item.count)).concat([1]))
        return Math.round((this.parseNumeric(value) / maximum) * 100)
      },
      setItemForceUpdate() {
        this.itemsForceUpdate = this.itemsForceUpdate + 1
      },

     
      getReportFilters() {
        var filters = JSON.parse(JSON.stringify(this.filters || {}))
        var seller = Helper.getSeller()
        if(seller) filters.sellers = [{ code: seller.id, label: seller.name }]
        return filters
      },
      loadReport(params) {
        return serviceAPI.getDynamicReport('orders', Object.assign(this.getReportFilters(), params))
      },
      downloadSource() {
        this.exporting = true
        serviceAPI.getReportExport('orders', this.getReportFilters())
          .then(response => Funciones.exportToCSV((response.data && response.data.detailItem) || [], 'source-order-detail-items'))
          .catch(error => this.showReportError(error))
          .finally(() => { this.exporting = false })
      },
      showReportError(error) {
        this.$awn.alert(error && error.message ? error.message : 'No se pudo cargar el reporte.')
      },
    },
  }
</script>
<style scoped>
  .metrics-dashboard{padding:.75rem}.metrics-dashboard__header,.metrics-panel>header,.metrics-row{display:flex;align-items:center;justify-content:space-between;gap:.75rem}.metrics-dashboard__header{margin-bottom:.75rem}.metrics-dashboard__header small,.metrics-panel header small{display:block;color:var(--app-color-text-muted);font-size:.75rem}.metrics-dashboard__stats{margin-bottom:.75rem}.metrics-stat,.metrics-panel{border:1px solid var(--app-color-border);border-radius:.35rem;background:var(--app-color-surface)}.metrics-stat{padding:1rem;min-height:86px}.metrics-stat small{display:block;color:var(--app-color-text-muted);font-size:.75rem}.metrics-stat strong{display:block;font-size:1.05rem;color:var(--app-color-text-primary)}.metrics-panel{overflow:hidden}.metrics-panel>header{padding:.65rem .75rem;background:var(--app-color-surface-subtle);border-bottom:1px solid var(--app-color-border)}.metrics-panel__rows{max-height:420px;overflow:auto}.metrics-row{padding:.55rem .75rem;border-bottom:1px solid var(--app-color-border);font-size:.82rem}.metrics-row:last-child{border-bottom:0}.metrics-row__rank{width:22px;height:22px;border-radius:50%;background:var(--app-color-primary-soft);color:var(--app-color-primary);text-align:center;line-height:22px;font-weight:700}.metrics-row__label{flex:1;min-width:0}.metrics-row__label strong{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.metrics-row__bar{display:block;height:3px;margin-top:.35rem;background:var(--app-color-border)}.metrics-row__bar i{display:block;height:100%;background:var(--app-color-primary)}.metrics-status{width:9px;height:9px;border-radius:50%}.metrics-empty{padding:1rem;text-align:center;color:var(--app-color-text-muted)}
</style>
